import { render } from "./DigitalAcceptComponent.vue?vue&type=template&id=d060df12&ts=true"
import script from "./DigitalAcceptComponent?vue&type=script&lang=ts"
export * from "./DigitalAcceptComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__